// extracted by mini-css-extract-plugin
export default {"footerContainer":"DiscardLearningGoalsModal__footerContainer___gLQWo","message":"DiscardLearningGoalsModal__message___aDAMc"};